"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    label: _propTypes.default.string,
    onChangeHandler: _propTypes.default.func,
    onReviewChangeHandler: _propTypes.default.func,
    accessible: _propTypes.default.bool,
    showError: _propTypes.default.bool,
    showReviewError: _propTypes.default.bool,
    reviewTitle: _propTypes.default.string,
    reviewSubtitle: _propTypes.default.string,
    reviewLabel: _propTypes.default.string,
    validationMessage: _propTypes.default.string,
    reviewValidationMessage: _propTypes.default.string,
    isMobile: _propTypes.default.bool,
    customReviewBoxHeight: _propTypes.default.string,
    customTitleBoxHeight: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    spanLabel: _propTypes.default.string,
    reviewSpanLabel: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isMobile: false,
    showError: false,
    showReviewError: false
  }
};
exports.default = _default;